/**
 * @generated SignedSource<<bd61021e972c8bad9a6a1b78c1e184bf>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type TimelineCellRenderer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"TimelineCell">;
  readonly " $fragmentType": "TimelineCellRenderer";
};
export type TimelineCellRenderer$key = {
  readonly " $data"?: TimelineCellRenderer$data;
  readonly " $fragmentSpreads": FragmentRefs<"TimelineCellRenderer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isTimelineEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "TimelineCellRenderer",
  "selections": [
    {
      "condition": "isTimelineEnabled",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "TimelineCell"
        }
      ]
    }
  ],
  "type": "JiraIssueField",
  "abstractKey": "__isJiraIssueField"
};

(node as any).hash = "6ad56faa45034ffc35668f1612648f21";

export default node;
